import BaseEnum from "./base_enum.js";

class InvestmentActivityStatusEnumDesc extends BaseEnum {

  name() {
    return "investment_activity_status";
  }

  rawValues() {
    return ["activated", "canceled"];
  }

}

const InvestmentActivityStatusEnum = new InvestmentActivityStatusEnumDesc();
export default InvestmentActivityStatusEnum;